import Model from './Model';

export default class Analytic extends Model {
  resource() {
    return 'analytics';
  }
}
